const NAVIGATION_FOCUSABLE_SELECTOR = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "summary",
    "[tabindex]:not([tabindex='-1'])",
].join(", ");

/** Returns only controls that can actually participate in an open navigation surface. */
export function navigationFocusableElements(root: ParentNode | null): HTMLElement[] {
    if (root === null) return [];

    return Array.from(root.querySelectorAll<HTMLElement>(NAVIGATION_FOCUSABLE_SELECTOR))
        .filter((element) => {
            if (element.closest("[hidden], [aria-hidden='true'], [inert]") !== null) {
                return false;
            }

            const closedDetails = element.closest("details:not([open])");

            if (closedDetails === null) return true;

            const visibleSummary = element.closest("summary");

            return visibleSummary !== null && visibleSummary.parentElement === closedDetails;
        });
}
